import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { FormBuilder } from "@angular/forms";

import { HexonProvider } from "../../providers/hexon/hexon";

@Component({
  selector: "page-site-settings",
  templateUrl: "site-settings.html",
})
export class SiteSettingsPage {
  public settings: ISiteSettings[];
  private formGroup;
  private sitecode: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private hexon: HexonProvider
  ) {
    this.settings = navParams.data.settings;
    this.sitecode = navParams.data.sitecode;

    this.formGroup = formBuilder.group(
      this.settings.reduce((acc, value) => {
        acc[value.setting] = [value.$value];

        return acc;
      }, {})
    );
  }

  public async update() {
    const newValues = this.settings
      .filter((setting) => this.formGroup.controls[setting.setting].touched)
      .map((setting) => {
        /* tslint:disable:no-any */
        let value = this.formGroup.value[setting.setting] as any;
        let dataType: string;

        switch (setting.data_type) {
          case "int":
            value = parseInt(value, 10);
            dataType = "value_int";
            break;
          case "set":
            dataType = "value_array";
            break;
          case "boolean":
            dataType = "value_boolean";
            break;
          default:
            dataType = "value_string";
            break;
        }

        return {
          setting_code: setting.setting,
          [dataType]: value,
        };
      });

    if (newValues.length) {
      try {
        await this.hexon
          .setSiteSettings$(this.sitecode, newValues)
          .first()
          .toPromise();
        this.navCtrl.pop();
      } catch (e) {}
    }
  }

  public cancel() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/site-settings/site-settings.ts